import { AdaptIDJobPostingSchema, JobListSchema, JobUserContextSchema } from "@app/schemas/jobs";
import { createReducer, on } from "@ngrx/store";
import { addGeneratedJobId, setAdeptIDJobPostings, setJobList, updateJobSortByOption, updateJobUserContext, updateUserJobFilterOptions } from "../actions/jobs.action";
import { JobFilterFormDataSchema } from "@app/schemas/job-filter";
import { JOB_FILTER_DEFAULT_OPTIONS } from "@app/utils/constants";

const initialJobList: JobListSchema[] = [];
export const jobListReducer = createReducer(
  initialJobList,
  on(setJobList, (_, action) => action.jobs),
);

const initalFilterOptions: JobFilterFormDataSchema = {
  role: JOB_FILTER_DEFAULT_OPTIONS.role,
  location: JOB_FILTER_DEFAULT_OPTIONS.location,
  education: JOB_FILTER_DEFAULT_OPTIONS.education,
  is_bookmarked: JOB_FILTER_DEFAULT_OPTIONS.is_bookmarked,
  is_related_to_career_goal: JOB_FILTER_DEFAULT_OPTIONS.is_related_to_career_goal,
};
export const jobFilterReducer = createReducer(
  initalFilterOptions,
  on(updateUserJobFilterOptions, (_, action) => action.filter),
);

const initalJobData: AdaptIDJobPostingSchema[] = [];
export const adaptIDJobPostingReducer = createReducer(
  initalJobData,
  on(setAdeptIDJobPostings, (_, action) => action.jobs),
);

const initialSortByOption: string = 'match_score';
export const jobSortByReducer = createReducer(
  initialSortByOption,
  on(updateJobSortByOption, (_, action) => action.sortBy),
);

const initalUserContext: JobUserContextSchema | {} = {};
export const jobUserContextReducer = createReducer(
  initalUserContext,
  on(updateJobUserContext, (_, action) => action.userContext),
);

const initialGeneratedJobIds: string[] = [];
export const generatedJobIdsReducer = createReducer(
  initialGeneratedJobIds,
  on(addGeneratedJobId, (state, action) => {
    if (state.includes(action.jobId)) {
      return state;
    }
    return [...state, action.jobId];
  }),
);